import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";

export default createQueryGroup(({ api }) => {
  return {
    list: () =>
      queryOptions({
        queryKey: ["serviceCode", "list"],
        queryFn: () => api.get("/agencies/:agencyId/service_codes", {}),
      }),
  };
});
